module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Light.f4bf8cc.ttf";